export interface CustomerProject {
  id: number;
  customerId: number;
  projectStatus?: number;
  name: string;
  visible: boolean;
  projectStatusIsActive: boolean;
  defaultBillingStatus: CustomerProjectBillingStatus;
  billingStatus: CustomerProjectBillingStatus;
  type: CustomerProjectTypeStatus;
  goLiveDate?: string;
  assignmentDescription?: string;
  solutionDescription?: string;
  notes?: string;
  responsibleForCustomer?: string;
  responsibleInternalUserId?: number;
  plannedTimeBudget?: number;
  assetTopLevelParenId?: number;
  assetId?: number;
  color?: string;
}

export interface CustomerProjectInputs {
  id: number;
  customerId?: number;
  projectStatus?: number;
  name: string;
  visible: boolean;
  defaultBillingStatus?: CustomerProjectBillingStatus;
  type?: CustomerProjectTypeStatus;
  goLiveDate?: string;
  assignmentDescription?: string;
  solutionDescription?: string;
  notes?: string;
  responsibleForCustomer?: string;
  responsibleInternalUserId?: number;
  plannedTimeBudget?: number;
  color?: string;
}

export enum CustomerProjectBillingStatus {
  TO_BE_INVOICED = 'ToBeInvoiced',
  INVOICED = 'Invoiced',
  FLAT_RATE = 'FlatRate',
  NOT_INVOICED = 'NotInvoiced',
  WILL_BE_INVOICED = 'WillBeInvoiced',
}

export enum CustomerProjectBillingStatusTranslation {
  'ToBeInvoiced' = 'To be invoiced',
  'Invoiced' = 'Invoiced',
  'FlatRate' = 'Flat rate',
  'NotInvoiced' = 'Not invoiced',
  'WillBeInvoiced' = 'Will be invoiced',
}

export enum CustomerProjectTypeStatus {
  ONE_OFF = 'OneOff',
  REPEATED = 'Repeated',
}

export enum CustomerProjectTypeTranslation {
  'OneOff' = 'One off',
  'Repeated' = 'Repeated',
}
